import React from "react";
import QuickLinksArrowIcon from "../../assets/images/QuickLinksArrowIcon";
import AddNewStaffIcon from "../../assets/images/AddNewStaffIcon";
import VerifyStaffIcon from "../../assets/images/VerifyStaffIcon";
import { useTranslation } from "react-i18next";
interface QuickLinksTileProps {
  title: string;
  description: string;
}
const QuickLinksTile = ({ title, description }: QuickLinksTileProps) => {
  const { t, i18n } = useTranslation();
  const componentMap: Record<string, React.ComponentType<any>> = {
    "Add New Staff": AddNewStaffIcon,
    "Employee List": VerifyStaffIcon,
    // "Verify Staff": VerifyStaffIcon,
    // "Assign Application": AssignApplicationIcon,
    // "Manage Roles": ManageRolesIcon,
  };
  const translatedTitle = t(title.replace(/\s/g, ""));
  const translatedDescription = t(description.replace(/\s/g, ""));
  const SelectedComponent = componentMap[title];
  return (
    <>
      <div className="block lg:hidden ">
        <div className="mt-2 py-2 px-2  rounded-lg  border border-gray-300   bg-whiteColor ">
          <div className="flex justify-between items-center">
            <div className="flex justify-start items-center gap-1 py-3">
              <div className="rounded-lg flex justify-center items-center   bg-sideMenubackground">
                {SelectedComponent && <SelectedComponent  height="24px" width="24px" />}
              </div>
              <div className=" text-dashBoardTileCountColor MobileResponsivestaffListHeader">
                {translatedTitle}
              </div>
            </div>
            <QuickLinksArrowIcon height="20px" width="20px" />
          </div>
        </div>
        </div>
      <div className=" hidden lg:block">
        <div className="mt-4 pt-6 rounded-lg ml-6 shadow-md  h-[132px] bg-whiteColor ">
          <div className="flex items-center">
            <div className="rounded-lg flex justify-center items-center ml-4 mr-3 bg-sideMenubackground h-10 w-10">
              {SelectedComponent && <SelectedComponent />}
            </div>
            <div className=" text-dashBoardTileCountColor quickLinksTitle">
              {translatedTitle}
            </div>
          </div>
          <div className="flex justify-between ">
            <div className="quickLinksDescription ml-4 mt-4  mr-6 text-inputTextColor">
              {translatedDescription}
            </div>
            <div className="pr-6 pt-6">
              <QuickLinksArrowIcon />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default QuickLinksTile;
